import { render, staticRenderFns } from "./LoginDealShift.vue?vue&type=template&id=3c2e3980&scoped=true&"
import script from "./LoginDealShift.vue?vue&type=script&lang=js&"
export * from "./LoginDealShift.vue?vue&type=script&lang=js&"
import style0 from "./LoginDealShift.vue?vue&type=style&index=0&id=3c2e3980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2e3980",
  null
  
)

export default component.exports